import { apiGateway } from "@/shared/apiGateway";

const searchPlant = (context, { searchCriteria }) => {
  var url = "api/profile/search-plant";
  if (searchCriteria.searchText != undefined) {
    url = url + "?searchText=" + searchCriteria.searchText;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      return data;
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error searching for plant"], {
        root: true
      });
    });
};

export default {
  searchPlant
};
